import { Pipe, PipeTransform } from '@angular/core';
import { ScoutTaskDoc } from '../../core/schema/scout-task-schema';
import { PathTestDoc } from '../../core/schema/path-test-schema';
import { DriveTestDoc } from '../../core/schema/drive-test-schema';

type Task = (ScoutTaskDoc|PathTestDoc|DriveTestDoc)&{row?:any}
@Pipe({
  name: 'taskRange'
})
export class TaskRangePipe implements PipeTransform {
  transform(tasks: Array<Task>, start: number, count: number): Task[] {
    const rtnTasks = tasks?.slice(start, start + count) || [];
    //console.log('taskRange: ', {tasksCount: tasks?.length, start, count});
    return rtnTasks;
  }
}